module.exports = __webpack_public_path__ + "img/home-credit.694cc142.svg";